// Module
var code = "<select class=\"form-control input-sm\" name=\"{{vm.name}}\" ng-model=\"vm.approvalStrategy\" ng-options=\"strategy.guid as strategy.name | translate for strategy in vm.approvalStrategies\" ng-change=\"vm.change()\" ng-disabled=\"vm.isDisabled\"> </select>";
// Exports
module.exports = code;